/** 로그인·가입 방식 (소셜·이메일, 확장 시 값 추가) */
export enum AuthProviderType {
  KAKAO = 'kakao',
  APPLE = 'apple',
  EMAIL = 'email',
}

export function parseAuthProviderType(value: unknown): AuthProviderType | null {
  if (
    value === AuthProviderType.KAKAO ||
    value === AuthProviderType.APPLE ||
    value === AuthProviderType.EMAIL
  ) {
    return value;
  }
  if (typeof value === 'string') {
    const v = value.toLowerCase();
    if (v === AuthProviderType.KAKAO) return AuthProviderType.KAKAO;
    if (v === AuthProviderType.APPLE) return AuthProviderType.APPLE;
    if (v === AuthProviderType.EMAIL) return AuthProviderType.EMAIL;
  }
  return null;
}
